import { CuiLayout } from 'cui';

const layouts = {
	TocEditorCuiLayout: async () => {
		const startupBundle = await import('startup');
		return startupBundle.TocEditorCuiLayout;
	}
};

export default async function getLayoutByName(
	layoutName: keyof typeof layouts
) {
	const getLayoutConstructor = layouts[layoutName];
	if (!getLayoutConstructor) {
		return CuiLayout;
	}

	return getLayoutConstructor();
}
